import { SocketIoConfig } from 'ngx-socket-io';

export const environment = {
  mainServer: 'https://test.leftyapp.com',
  mainUrlWeb: 'https://veggly-v3-dev.web.app',
  //mainServer: 'http://localhost:8080',
  imgServer: 'https://test.leftyapp.com',
  //socketServer: 'test.leftyapp.com',
  socketServer: 'test.leftyapp.com',
  production: false,
  requestTimeout: 30000,
  priceVegBoost: 5,
  priceSuperLike: 1,
  locationDefault: { type: 'Point', coordinates: [-0.118092, 51.509865] },
  mapbox: {
    token: 'pk.eyJ1IjoiYW5kcmVwYWl2YSIsImEiOiJjbWkzMWZ3emoxZmkyMmpwd3ZuazNyY2ltIn0.QJITkWgCFsXWLWnKqZbpmg',
  },
  googleAuth: {
    ios: '888967854315-emft4oe6s4d3a7v9qv96ttrl7rt2u2d0.apps.googleusercontent.com',
    android: '888967854315-33isdqp5n73btjb40961uaiba28pv6ot.apps.googleusercontent.com',
    web: '888967854315-33isdqp5n73btjb40961uaiba28pv6ot.apps.googleusercontent.com',
  },
  products: {
    oneCoin: {
      id: 'leftyapp.1coin',
      alias: '1 Coin',
      price: '$2.00 USD',
      priceNumber: 2.00,
      priceMicros: 1 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    tenCoin: {
      id: 'leftyapp.10coins',
      alias: '10 Coins',
      price: '$8.00 USD',
      priceNumber: 8.00,
      priceMicros: 8 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    fiftyCoin: {
      id: 'leftyapp.50coins',
      alias: '50 Coins',
      price: '$25.00 USD',
      priceNumber: 25.00,
      priceMicros: 25 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    hundredCoin: {
      id: 'leftyapp.100coins',
      alias: '100 Coins',
      price: '$40.00 USD',
      priceNumber: 40.00,
      priceMicros: 40 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    club: {
      id: 'leftypremium',
      name: 'Lefty Premium',
      price: '$12.00 USD',
      priceMicros: 5 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
    },
    club_3_months: {
      id: 'leftypremium3months',
      name: 'Lefty Premium 3 Months',
      price: '$27.00 USD',
      priceMicros: 12 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 20,
    },
    club_6_months: {
      id: 'leftypremium6months',
      name: 'Lefty Premium 6 Months',
      price: '$52.00 USD',
      priceMicros: 21 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 30,
    },
    club_12_months: {
      id: 'leftypremium12months',
      name: 'Lefty Premium 12 Months',
      price: '$87.00 USD',
      priceMicros: 33.6 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 44,
    },
    club_30percent_off: {
      id: 'leftypremium30percentoff',
      name: 'Lefty Premium 30% Off',
      price: '$8.40 USD',
      priceMicros: 8.4 * 1000 * 1000,
      priceSet: false,
      priceMicrosSet: false,
      discount: 30,
    },
    productCurrency: 'BRL',
    tenCoinDiscount: 20,
    fiftyCoinDiscount: 50,
    hundredCoinDiscount: 60,
    urlValidator: "https://validator.iaptic.com/v1/validate?appName=com.leftyapp&apiKey=6bbffb48-b5d2-41e6-80c6-669381cd66f5"
  },
  adjustDownloadLink: 'https://app.adjust.com/12vohm6r'
};

export const webVersion: string = 'web-2.0.0';

export const configSocketIO: SocketIoConfig = {
  url: 'wss://' + environment.socketServer + '/',
  options: {}
};
